// extracted by mini-css-extract-plugin
export default {"headerWrapper":"ModalHeader_headerWrapper__AIMCV","closeButton":"ModalHeader_closeButton__gSkId"};